module.exports = __webpack_public_path__ + "img/593394d.png";